"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _loading = require("./loading.js");
var getRiskAction = function getRiskAction(action, questionBankId, userId) {
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000 * 60 * 60;
  var dispatch = (0, _reactRedux.useDispatch)();
  var key = action.getKey();
  var loaded = (0, _loading.useIsLoaded)(key);
  var loading = (0, _loading.useIsLoading)(key);
  var stale = (0, _reactRedux.useSelector)(function (state) {
    return new Date().getTime() - state.loadedAt.get(key, 0) > duration;
  });
  (0, _react.useEffect)(function () {
    if (loading || loaded && !stale) return;
    dispatch(action(questionBankId, userId));
  }, [loaded, stale]);
  return loading || !loaded;
};
var RiskAssessmentHooks = /*#__PURE__*/_createClass(function RiskAssessmentHooks(_ref) {
  var _this = this;
  var RiskAssessment = _ref.RiskAssessment;
  _classCallCheck(this, RiskAssessmentHooks);
  this.RiskAssessment = RiskAssessment;
  this.useLoadRiskAssessment = function (questionBankId) {
    var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return getRiskAction(_this.RiskAssessment.riskFetch, questionBankId, userId);
  };
});
exports.default = RiskAssessmentHooks;